export default class DmLang {
  constructor(options) {
    this._message = options.message
    this.locale = options.locale
  }
  _t (key, _locale, messages) {
    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
    var keys = key.split('.');
    if (keys.length > 0) {
      return this.getPathValue(messages[_locale || 'default'], key);
    } else {
      return '';
    }
  }
  getPathValue (obj, path) {
    var i = 0, paths = path.split('.');
    var len = paths.length
    if (len == 0) return '';

    var ret = null;
    var last = obj;
    while (len > i) {
      var value = last[paths[i]];
      if (value === undefined) {
        last = null;
        break
      }
      last = value;
      i++;
    }
    ret = last;
    return ret;
  }
  getMessage () {
    return this._message;
  }
}
DmLang.install = (Vue) => {
  Object.defineProperty(Vue.prototype,'$dmLang', {
    get: function () {
      return this._dmLang;
    }
  })
  Vue.prototype.$dmt = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
    var dmLang = this.$dmLang;
    return dmLang._t.apply(dmLang, [key, dmLang.locale, dmLang.getMessage(), this].concat(values))
  }

  Vue.mixin({
    beforeCreate() {
      var options = this.$options
      if (options.dmLang && options.dmLang instanceof DmLang) {
        this._dmLang = options.dmLang
      } else if (this.$root && this.$root._dmLang && this.$root._dmLang instanceof DmLang) {
        this._dmLang = this.$root._dmLang;
      }
    },
  })
}
